import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Gracias a esta póliza, cuando mi mamá partió, no tuvimos que preocuparnos por el dinero. Solo por despedirnos con amor.',
    author: 'Carmen R.',
    details: '58 años, Texas',
    image: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?w=200&q=80'
  }, {
    quote: 'Pensé que por mi edad y mis problemas de salud no me aprobarían. Me equivoqué. En 10 minutos ya tenía mi póliza.',
    author: 'Roberto M.',
    details: '71 años, Florida',
    image: 'https://images.unsplash.com/photo-1559526323-cb2f2fe2591b?w=200&q=80'
  }];
  return <section className="py-[50px] md:py-[80px] px-6 bg-brand-lighterGray border-t-2 border-brand-gold" data-id="element-170">
      <div className="max-w-[900px] mx-auto" data-id="element-171">
        <FadeIn data-id="element-172">
          <h2 className="text-[32px] md:text-[36px] font-bold text-white text-center mb-16" data-id="element-173">
            Familias Reales. Historias Reales.
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-174">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-175">
              <div className="bg-brand-black rounded-2xl p-8 h-full border border-white/5 flex flex-col items-center text-center" data-id="element-176">
                <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-brand-gold mb-6 shadow-lg" data-id="element-177">
                  <img src={testimonial.image} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-178" />
                </div>

                <p className="text-[18px] text-brand-lightGray italic mb-8 leading-relaxed flex-grow" data-id="element-179">
                  "{testimonial.quote}"
                </p>

                <div className="mt-auto" data-id="element-180">
                  <p className="text-white font-bold text-[16px] mb-1" data-id="element-181">
                    — {testimonial.author}, {testimonial.details}
                  </p>
                  <div className="flex justify-center gap-1 text-brand-gold" data-id="element-182">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-183" />)}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}